import React from "react";
import {
  Button,
  Container,
  H1,
  H2,
  Section,
  Span,
} from "../../Styles/Global.Styled";
import { useNavigate } from "react-router-dom";
import { css } from "styled-components";
import landingBg from "../../assets/Images/landingBg.jpg";
import cutFlowers from "../../assets/Images/cutFlowers.jpeg";
import housePlantsBG from "../../assets/Images/housePlantsBG.jpeg";
import seedsBG from "../../assets/Images/seedsBG.jpeg";
import accessoriesBg from "../../assets/Images/accessoriesBg1.jpeg";

const saleCategoriesContent = [
  {
    name: "Cut Flowers",
    id: "Cut flowers",
    buttonImage: cutFlowers,
  },
  {
    name: "Home Plants",
    id: "Houseplants",
    buttonImage: housePlantsBG,
  },
  {
    name: "Seeds",
    id: "Seeds",
    buttonImage: seedsBG,
  },
  {
    name: "Accessories",
    id: "Accessories",
    buttonImage: accessoriesBg,
  },
];

const sectionStyle = css`
  flex-direction: row;
  box-shadow: 0 -2px 2px ${({ theme }) => theme.shadowColor} inset;
  background-color: ${({ theme }) => theme.bgColor};
  padding: 3vh 10vw;
  gap: 1vh;
`;
const sectionStyleMb = css`
  padding: 1vh 2vw 2vh;
  flex-direction: column-reverse;
`;

const bttnsContainer = css`
  flex-direction: column;
  width: 30%;
  gap: 1vh;
`;
const bttnsContainerMb = css`
  width: 100%;
`;

const bttnStyle = (pic) => css`
  background-image: url(${pic});
  background-size: cover;
  background-position: center center;
  flex-direction: column;
  color: white;
  padding: 4vh 0;
  flex-grow: 1;
  border-radius: 12px;
  font-size: 3.5vh;
`;
const bttnStyleMb = css`
  padding: 2vh 0;
`;
const bttnTxt = css`
  font-size: 1.5vh;
  border: 2px solid white;
  padding: 0.5vh 1.5vh;
  border-radius: 25px;
`;

const mainContainer = (picture) => css`
  background-image: url(${picture});
  background-size: cover;
  background-position: center center;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 70%;
  gap: 1vh;
  border-radius: 12px;
  box-shadow: 0 0 2px 2px ${({ theme }) => theme.shadowColor};
`;
const mainContainerMb = css`
  width: 100%;
  padding: 10vh 0;
`;

const mainBttn1 = css`
  background-color: ${({ theme }) => theme.main};
  border-radius: 25px;
  color: white;
  padding: 1vh 0;
  width: 10vw;
  font-size: 1.75vh;
  white-space: nowrap;
`;
const mainBttnMb1 = css`
  width: 30vw;
  font-size: 1.5vh;
`;

const secBttn1 = css`
  border: 2px solid ${({ theme }) => theme.main};
  color: ${({ theme }) => theme.main};
  border-radius: 25px;
  padding: 1vh 0;
  width: 10vw;
  font-size: 1.75vh;
  white-space: nowrap;
`;

const h2Style = css`
  font-size: 2.5vh;
`;
const hideDisplay = css`
  display: none;
`;
const gapSize1 = css`
  gap: 1vw;
`;

const Landing = () => {
  const navigate = useNavigate();

  return (
    <Section id="landing" $baseStyle={sectionStyle} $mStyle={sectionStyleMb}>
      <Container $baseStyle={bttnsContainer} $mStyle={bttnsContainerMb}>
        {saleCategoriesContent.map((saleCat, index) => (
          <Button
            key={index}
            $baseStyle={bttnStyle(saleCat.buttonImage)}
            $mStyle={bttnStyleMb}
            id={saleCat.id}
            onClick={() => navigate("/shop")}
          >
            {saleCat.name}
            <Span $baseStyle={bttnTxt}>Shop now</Span>
          </Button>
        ))}
      </Container>
      <Container
        $baseStyle={mainContainer(landingBg)}
        $mStyle={mainContainerMb}
      >
        <H2 $baseStyle={h2Style} $mStyle={hideDisplay}>
          Wholesale Blooms, Business Booms
        </H2>
        <H1>Fresh Flowers Supply</H1>
        <Container $baseStyle={gapSize1}>
          <Button
            $baseStyle={mainBttn1}
            $mStyle={mainBttnMb1}
            onClick={() => navigate("/shop")}
          >
            Shop now
          </Button>
          <Button $baseStyle={secBttn1} $mStyle={mainBttnMb1}>
            Get a Qoute
          </Button>
        </Container>
      </Container>
    </Section>
  );
};

export default Landing;
